import { render, staticRenderFns } from "./limitDetails.vue?vue&type=template&id=6eb5b554&scoped=true&"
import script from "./limitDetails.vue?vue&type=script&lang=js&"
export * from "./limitDetails.vue?vue&type=script&lang=js&"
import style0 from "./limitDetails.vue?vue&type=style&index=0&id=6eb5b554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb5b554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb5b554')) {
      api.createRecord('6eb5b554', component.options)
    } else {
      api.reload('6eb5b554', component.options)
    }
    module.hot.accept("./limitDetails.vue?vue&type=template&id=6eb5b554&scoped=true&", function () {
      api.rerender('6eb5b554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/email/components/limitDetails.vue"
export default component.exports